import { useMutation } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { Alert } from '../models';

const updateAlert = async (
    payload: Partial<Alert>,
    alertId?: number,
): Promise<{ message: string }> => {
    const response = await RQAPICallWithData<Alert>({
        endpoint: `alert/${alertId}`,
        method: 'PUT',
        body: payload,
    });
    return response.content;
};

/**
 * RQ Hook to update an existing alert based on the relevant data.
 * @param {number} alertId - The id of the alert to be updated
 * @param {(alert: Alert) => void} onSuccess - A callback function to be executed on success
 */
export const useUpdateAlert = (
    alertId?: number,
    onSuccess?: (message?: string, alert?: Alert) => void,
) => {
    return useMutation({
        mutationFn: (payload: Partial<Alert>) => updateAlert(payload, alertId),

        onSuccess: ({ message }) => {
            if (onSuccess) {
                onSuccess(message);
            }
        },
        meta: { useGlobalOnError: true },
    });
};
